import React from "react";

const OnboardingProgress = ({ currentStep, totalSteps }) => {
  return (
    <div className="onb-progress">
      <div className="onb-progress__steps">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`onb-progress__dot ${
              index === currentStep
                ? "onb-progress__dot--active"
                : index < currentStep
                ? "onb-progress__dot--completed"
                : ""
            }`}
          />
        ))}
      </div>
      <span className="onb-progress__label">
        {currentStep + 1}/{totalSteps}
      </span>
    </div>
  );
};

export default OnboardingProgress;
